module.exports = __webpack_public_path__ + "static/emergencycall-ddd04ed82d824ab1eee61e8f9baa836f.png";